import constants from '../../constants'

const CloseIconLarge = ({ ...props }) => {
  return constants.BRAND === 'sports-research' ? (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8533 7.53242C22.2438 7.1419 22.2438 6.50873 21.8533 6.11821C21.4628 5.72769 20.8296 5.72769 20.4391 6.11821L14.0568 12.5005L7.70711 6.15073C7.31658 5.7602 6.68342 5.7602 6.29289 6.15073C5.90237 6.54125 5.90237 7.17442 6.29289 7.56494L12.6426 13.9147L6.29695 20.2603C5.90642 20.6509 5.90642 21.284 6.29695 21.6746C6.68747 22.0651 7.32064 22.0651 7.71116 21.6746L14.0568 15.3289L20.435 21.7071C20.8256 22.0976 21.4587 22.0976 21.8492 21.7071C22.2398 21.3166 22.2398 20.6834 21.8492 20.2929L15.4711 13.9147L21.8533 7.53242Z"
        fill="#212721"
      />
    </svg>
  ) : (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1301 3.12727C20.6125 2.64486 20.6125 1.86272 20.1301 1.3803C19.6477 0.897891 18.8656 0.897891 18.3832 1.3803L10.4988 9.26463L2.65565 1.42145C2.17324 0.939036 1.3911 0.939036 0.908684 1.42145C0.426272 1.90386 0.426272 2.68601 0.908684 3.16842L8.75186 11.0116L0.913463 18.85C0.431051 19.3324 0.431051 20.1146 0.913463 20.597C1.39588 21.0794 2.17802 21.0794 2.66043 20.597L10.4988 12.7586L18.3784 20.6381C18.8608 21.1205 19.6429 21.1205 20.1253 20.6381C20.6078 20.1557 20.6078 19.3736 20.1253 18.8911L12.2458 11.0116L20.1301 3.12727Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default CloseIconLarge
